<script lang="ts" setup>
import type { RadioFilter } from '~/types/Catalog';
import { cloneValue } from '~/utils/cloneValue';

const props = defineProps<{ filter: RadioFilter }>();
const route = useRoute();

const activeItem = ref<string | number>();

onMounted(() => {
  setActiveItemFromProps();
});

async function handleFilterChange(e: any) {
  activeItem.value = e.target.id;

  const filterSlug = `filter[${props.filter.slug}]`;
  const query = cloneValue(route.query);

  if (query.page) delete query.page;
  if (query['filter[warehouse]']) delete query['filter[warehouse]']; // костыль

  if (activeItem.value) {
    await navigateTo({
      path: route.path,
      query: { ...query, [filterSlug]: activeItem.value },
    });
  } else if (query[filterSlug]) {
    delete query[filterSlug];

    await navigateTo({
      path: route.path,
      query,
    });
  }
}

watch(
  () => props.filter.options,
  () => setActiveItemFromProps(),
);

watch(
  () => route.query,
  () => {
    const query = cloneValue(route.query);

    if (query['filter[search]']) {
      delete query['filter[search]'];
    }

    if (Object.keys(query).length === 0 || !query[`filter[${props.filter.slug}]`]) {
      activeItem.value = '';
    }
  },
);

function setActiveItemFromProps() {
  const activeOption = props.filter.options.find((o) => o.state);
  if (activeOption) activeItem.value = activeOption.value;
}
</script>

<template>
  <div
    class="radio-filter"
    @click="handleFilterChange"
  >
    <div
      v-for="item in filter.options"
      :key="item.value"
      class="radio-filter__item"
    >
      <input
        :id="String(item.value)"
        :checked="item.value === activeItem"
        type="radio"
      />

      <label
        :for="String(item.value)"
        class="radio-filter__text"
      >
        {{ item.text }}
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.radio-filter {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__item {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  &__text {
    margin-bottom: 2px;
    font-size: $text-sm;
  }
}
</style>
